import React from 'react'
import Spinner from 'react-bootstrap/esm/Spinner'

function LoadingOverlaySpinner() {
  return (
    <div className="overlay-container--indicator">
      <Spinner animation="border" role="status" aria-label="Loading" variant="primary" />
    </div>
  )
}

export default LoadingOverlaySpinner
